module.exports = __webpack_public_path__ + "static/media/Owner_Login2x.2aeea943.png";